export const filmographyGroups = [
  {
    id: 'g1',
    title: '最新整理',
    caption: '近期公开方向',
    items: [
      {
        id: 'g1i1',
        name: '剧情向整理 · 都市篇',
        note: '以都市情感为主线，注重人物关系与叙事节奏，适合按顺序观看。',
        tags: ['剧情', '都市'],
      },
      {
        id: 'g1i2',
        name: '影像向合集 · 写真氛围',
        note: '氛围与光影优先，节奏轻缓，画面风格统一。',
        tags: ['影像', '氛围'],
      },
      {
        id: 'g1i3',
        name: '合作企划整理 · 联名特辑',
        note: '含幕后花絮与访谈片段，信息量偏幕后。',
        tags: ['合作', '花絮'],
      },
    ],
  },
  {
    id: 'g2',
    title: '近年回顾',
    caption: '形成稳定风格的一批内容',
    items: [
      {
        id: 'g2i1',
        name: '剧情向整理 · 古典篇',
        note: '复古置景与暖色调，慢节奏叙事，强调场景营造。',
        tags: ['复古', '剧情'],
      },
      {
        id: 'g2i2',
        name: '影像向合集 · 城市漫游',
        note: '外景为主，记录街景与日常片段，观感轻松。',
        tags: ['外景', '日常'],
      },
      {
        id: 'g2i3',
        name: '主题写真 · 四季系列',
        note: '按季节划分的写真主题，用色调区分氛围，便于按喜好挑选。',
        tags: ['写真', '主题'],
      },
    ],
  },
  {
    id: 'g3',
    title: '早期内容',
    caption: '风格尚未定型的探索期',
    items: [
      {
        id: 'g3i1',
        name: '早期影像合集',
        note: '制作更轻量，画面偏记录感，适合作为风格对比参考。',
        tags: ['早期', '影像'],
      },
      {
        id: 'g3i2',
        name: '早期写真整理',
        note: '以清爽自然的表达为主，与后期风格差异较明显。',
        tags: ['早期', '写真'],
      },
      {
        id: 'g3i3',
        name: '纪念企划整理 · 回顾特辑',
        note: '串联不同时期的代表方向，适合一次看整体变化。',
        tags: ['回顾', '里程碑'],
      },
    ],
  },
];